import { useState } from "react";

export default function CreateCompetitionForm({ onSubmit, competition }: { onSubmit: (data: any) => void, competition?: any }) {

    const isNew = competition === null || competition === undefined;

    const [form, setForm] = useState({
        name: competition?.name ?? "",
        date: competition?.date ?? "",
        type: competition?.type ?? 1,
        with_video: competition?.with_video ?? false,
        with_photo: competition?.with_photo ?? true,
        video_soldout: competition?.video_soldout ?? false,
        published: competition?.published ?? false,
        pos: competition?.pos ?? 0,
        price_photo: competition?.price_photo ?? 0,
        price_video: competition?.price_video ?? 0,
        currency: competition?.currency ?? "usd",
    });

    function updateField(key, value) {
        setForm(prev => ({ ...prev, [key]: value }));
    }

    function handleSubmit(e) {
        e.preventDefault();
        onSubmit(form);
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6 max-w-xl mx-auto p-6 bg-white rounded-xl shadow">

            <h2 className="text-2xl font-semibold mb-4">{isNew ? "Create Competition" : "Edit Competition"}</h2>

            {/* NAME */}
            <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                    type="text"
                    defaultValue={form.name}
                    onChange={(e) => updateField("name", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            {/* DATE */}
            <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                    type="text"
                    defaultValue={form.date}
                    onChange={(e) => updateField("date", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            {/* TYPE */}
            <div>
                <label className="block text-sm font-medium mb-1">Type</label>
                <select
                    defaultValue={form.type}
                    onChange={(e) => updateField("type", Number(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    <option value="1">Художественная гимнастика</option>
                    <option value="2">Фигурное катание</option>
                </select>
            </div>

            {/* SWITCHES */}
            <div className="grid grid-cols-2 gap-4">

                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        defaultChecked={form.with_video}
                        onChange={(e) => updateField("with_video", e.target.checked)}
                        className="h-4 w-4"
                    />
                    <span>With Video</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        defaultChecked={form.with_photo}
                        onChange={(e) => updateField("with_photo", e.target.checked)}
                        className="h-4 w-4"
                    />
                    <span>With Photo</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        defaultChecked={form.video_soldout}
                        onChange={(e) => updateField("video_soldout", e.target.checked)}
                        className="h-4 w-4"
                    />
                    <span>Video Sold Out</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="checkbox"
                        defaultChecked={form.published}
                        onChange={(e) => updateField("published", e.target.checked)}
                        className="h-4 w-4"
                    />
                    <span>Published</span>
                </label>

            </div>

            {/* POS */}
            <div>
                <label className="block text-sm font-medium mb-1">Order (pos)</label>
                <input
                    type="number"
                    defaultValue={form.pos}
                    onChange={(e) => updateField("pos", Number(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            {/* PRICES */}
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Photo Price</label>
                    <input
                        type="number"
                        defaultValue={form.price_photo}
                        onChange={(e) => updateField("price_photo", e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg
                                   focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium mb-1">Video Price</label>
                    <input
                        type="number"
                        defaultValue={form.price_video}
                        onChange={(e) => updateField("price_video", e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg
                                   focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">Currency</label>
                <select
                    defaultValue={form.currency}
                    onChange={(e) => updateField("currency", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    <option value="usd">USD</option>
                    <option value="cad">CAD</option>
                    <option value="eur">EUR</option>
                </select>
            </div>

            {/* SAVE BUTTON */}
            <button
                type="submit"
                className="w-full py-2 px-4 bg-indigo-600 text-white rounded-lg
                           hover:bg-indigo-700 transition font-medium"
            >
                {isNew ? "Create Competition" : "Save Changes"}
            </button>
        </form>
    );
}